import enviro from 'enviro';
import { urlBase64ToUint8Array } from '../../../utils/EncodingUtil';
const VAPID_QA_PUBLIC_KEY = 'BKWUzaaTCMi91x-vrvnDMCBauMuHFOHvqf3xy5cYYHTrSHrqcBegTCrvxw0xmbPiBZQeigb2Ut9OYFr7jyyOau0';
const VAPID_PROD_PUBLIC_KEY = 'BNoT2GhFilVOiVkbpTS_h3wiFEt7DdIx9R8VEmGpUiZitUWMAg_PBuP5c6J8uvN6uLls2lnXNGQEgS_VNSERvXo';
const getVapidKey = () => enviro.isQa() ? VAPID_QA_PUBLIC_KEY : VAPID_PROD_PUBLIC_KEY;
export const getPushSubscriptionOptions = () => {
  return {
    applicationServerKey: urlBase64ToUint8Array(getVapidKey()),
    userVisibleOnly: true
  };
};